const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 40,
    stroke: "#ACB3BF",
    style: {
      stroke: "#ACB3BF",
      stroke: "color(display-p3 0.6745 0.7020 0.7490)",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeDasharray: "2 10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.0001,
    cy: 42.0001,
    r: 35.0685,
    fill: "#F1F3F4",
    style: {
      fill: "#F1F3F4",
      fill: "color(display-p3 0.9451 0.9529 0.9569)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3585 42.0619C57.9885 42.0619 58.5 42.5634 58.5 43.1827C58.5 43.8005 57.9885 44.3006 57.3585 44.3006H55.7655V49.6399C55.7655 52.873 53.085 55.5 49.791 55.5H47.4015C46.77 55.5 46.2585 54.9984 46.2585 54.3792C46.2585 53.7614 46.77 53.2598 47.4015 53.2598H49.791C51.8265 53.2598 53.4825 51.6374 53.4825 49.6399V44.3006H49.548V45.7876C49.563 47.6483 48.0405 49.1692 46.143 49.1869H37.857C35.961 49.1692 34.4385 47.6483 34.4535 45.7876V44.3006H30.519V49.6458C30.519 51.6359 32.1705 53.2554 34.2 53.2583L36.642 53.2598C37.272 53.2598 37.7835 53.7614 37.7835 54.3792C37.782 54.9984 37.272 55.5 36.6405 55.5L34.197 55.4985C30.9105 55.4956 28.2345 52.87 28.2345 49.6458V44.3006H26.643C26.013 44.3006 25.5 43.8005 25.5 43.1827C25.5 42.5634 26.013 42.0619 26.643 42.0619H57.3585ZM46.1437 34.114C47.0513 34.114 47.9228 34.4714 48.5573 35.1083C49.1963 35.7511 49.5502 36.6145 49.5488 37.5132V39.3813C49.5413 39.6004 49.3627 39.7784 49.1392 39.7843H34.8593C34.6372 39.777 34.4587 39.599 34.4541 39.3813V37.5132C34.4377 35.6525 35.9617 34.1331 37.8577 34.114H46.1437ZM49.7904 28.5004C53.0859 28.5004 55.7649 31.1275 55.7649 34.359V37.1435C55.7649 37.7612 55.2549 38.2643 54.6234 38.2643C53.9934 38.2643 53.4819 37.7612 53.4819 37.1435V34.359C53.4819 32.363 51.8259 30.7392 49.7904 30.7392H47.4009C46.7709 30.7392 46.2594 30.239 46.2594 29.6213C46.2594 29.002 46.7709 28.5004 47.4009 28.5004H49.7904ZM36.6416 28.5C37.2716 28.5 37.783 29.0016 37.783 29.6208C37.783 30.2386 37.2731 30.7402 36.6416 30.7402L34.198 30.7417C32.17 30.7446 30.5201 32.3641 30.5201 34.3542V37.143C30.5201 37.7608 30.0071 38.2638 29.3771 38.2638C28.7471 38.2638 28.2355 37.7608 28.2355 37.143V34.3542C28.2355 31.13 30.91 28.5044 34.1966 28.5015L36.6416 28.5Z",
    fill: "#B1B7C3",
    style: {
      fill: "#B1B7C3",
      fill: "color(display-p3 0.6941 0.7176 0.7647)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.dbe8a64f2f4df1d350256b986433910f.svg";
export { ForwardRef as ReactComponent };